﻿import {
    ValgStateActionTypes,
    TOGGLE_FORELDREANSVAR,
    ToggleForeldreansvarAction,
    TOGGLE_VILKAR,
    ToggleVilkarAction,
    ValgState,
    UPDATE_VALG,
} from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederIasAppState } from '..';
import { AnyAction } from 'redux';
import { getA, getB, getBx, getC } from '../../Veileder';
import { setVisning } from '../Resultat/Actions';
import AFamiliesituasjonsValg from '../../Utilities/A-FamiliesituasjonValg';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleForeldreansvar(): ToggleForeldreansvarAction {
    return {
        type: TOGGLE_FORELDREANSVAR,
    };
}

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederIasAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederIasAppState, {}, AnyAction>, getState: () => VeilederIasAppState): void => {
        const currentState = getState();
        const visBoksB = visB(currentState);
        const visBoksBx = visBx(currentState);
        const visBoksC = visC(currentState);
        const visResultat = visR(currentState);
        const visTabell = visT(currentState, visBoksC);

        dispatch(
            setVisning({
                visBoksB,
                visBoksBx,
                visBoksC,
                visResultat,
                visTabell,
            }),
        );
    };
};

const visB = (state: VeilederIasAppState): boolean => {
    return getA(state.valg) === AFamiliesituasjonsValg.a2_borIkkeSammen;
};

const visBx = (state: VeilederIasAppState): boolean => {
    return getA(state.valg) === AFamiliesituasjonsValg.a3_enForelder;
};

const visC = (state: VeilederIasAppState): boolean => {
    return (
        getA(state.valg) === AFamiliesituasjonsValg.a1_borSammen ||
        (getA(state.valg) === AFamiliesituasjonsValg.a2_borIkkeSammen && getB(state.valg) !== undefined) ||
        getBx(state.valg) !== undefined ||
        (getA(state.valg) === AFamiliesituasjonsValg.a3_enForelder && getB(state.valg) !== undefined) ||
        getBx(state.valg) !== undefined
    );
};

const visR = (state: VeilederIasAppState): boolean => {
    return getA(state.valg) === AFamiliesituasjonsValg.a4_fosterhjemBarnevern;
};

const visT = (state: VeilederIasAppState, visBoksC: boolean): boolean => {
    return visBoksC && getC(state.valg) !== undefined;
};
